'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defaultResourceReducer = require('./defaultResourceReducer');

var _defaultResourceReducer2 = _interopRequireDefault(_defaultResourceReducer);

var _elementsResourceReducer = require('../../../../../element/elementsResourceReducer');

var _elementsResourceReducer2 = _interopRequireDefault(_elementsResourceReducer);

var _boardsResourceReducer = require('../../../../../element/board/boardsResourceReducer');

var _boardsResourceReducer2 = _interopRequireDefault(_boardsResourceReducer);

var _resourceConstants = require('../resourceConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Reducers
exports.default = function (resourceType) {
    switch (resourceType) {
        case _resourceConstants.RESOURCE_TYPES.elements:
            return _elementsResourceReducer2.default;
        case _resourceConstants.RESOURCE_TYPES.boards:
            return _boardsResourceReducer2.default;
        default:
            return _defaultResourceReducer2.default;
    }
};

// Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/resources/reducers/getResourceReducer.js
// module id = 2135
// module chunks = 0